import { render, staticRenderFns } from "./customer-applicant.vue?vue&type=template&id=732c21c6&scoped=true&"
import script from "./customer-applicant.vue?vue&type=script&lang=js&"
export * from "./customer-applicant.vue?vue&type=script&lang=js&"
import style0 from "./customer-applicant.vue?vue&type=style&index=0&id=732c21c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c21c6",
  null
  
)

export default component.exports